
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { supabase } from "@/integrations/supabase/client";
import AdminHeader from '@/components/admin/AdminHeader';
import { useToast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import AdminPageLoader from '@/components/admin/AdminPageLoader';
import BadgesManagement from '@/components/admin/badges/BadgesManagement';

const AdminBadges = () => {
  const { t } = useTranslation(['admin', 'common']);
  const { user } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        if (!user) {
          navigate('/login');
          return;
        }

        // Check if user has admin privileges
        const { data, error } = await supabase
          .from('customer_profiles')
          .select('tier')
          .eq('id', user.id)
          .single();

        if (error) throw error;

        if (data.tier !== 'admin') {
          toast({
            title: t('admin:accessDenied'),
            description: t('admin:notAuthorized'),
            variant: 'destructive',
          });
          navigate('/dashboard');
        } else {
          setIsAdmin(true);
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
        navigate('/dashboard');
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [user, navigate, toast, t]);

  if (loading) {
    return <AdminPageLoader />;
  }

  if (!isAdmin) {
    return null; // Will redirect in useEffect
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F8F7F5] to-[#F5EBD8]/30">
      <AdminHeader />
      
      <main className="container mx-auto py-8 px-4">
        <h1 className="text-3xl font-bold mb-6">{t('admin:badgesManagement')}</h1>
        
        <BadgesManagement />
      </main>
    </div>
  );
};

export default AdminBadges;
